import React from 'react';

const TooltipChoice = Object.freeze({
  NO_REQUESTS: Symbol('NO_REQUESTS'),
  NO_FEEDBACK: Symbol('NO_FEEDBACK'),
  LESS_THAN_HALF: Symbol('LESS_THAN_HALF'),
  MANY_RESPONDED: Symbol('MANY_RESPONDED'),
  ALL_RESPONDED: Symbol('ALL_RESPONDED'),
});

export class ManagerRespondedTooltip extends React.Component {
  getTooltipChoice(totalRequests, requestsRespondedTo) {
    const pct = totalRequests ? (requestsRespondedTo / totalRequests) * 100 : 0;

    if (totalRequests === 0) {
      return TooltipChoice.NO_REQUESTS;
    } else if (requestsRespondedTo === 0) {
      return TooltipChoice.NO_FEEDBACK;
    } else if (pct < 50.0 && totalRequests > 10) {
      return TooltipChoice.LESS_THAN_HALF;
    } else if (pct <= 99.0 || totalRequests <= 10) {
      return TooltipChoice.MANY_RESPONDED;
    } else {
      return TooltipChoice.ALL_RESPONDED;
    }
  }

  render() {
    const {totalRequests, requestsRespondedTo, name} = this.props;

    const tooltipChoice = this.getTooltipChoice(totalRequests, requestsRespondedTo);

    return (
      <div>
        {tooltipChoice === TooltipChoice.NO_REQUESTS && (
          <p>
            {`Agents did not request feedback from ${name} in this period. Agents can request feedback
            by clicking the icon under their profile image on any call. Some dialers also support
            requesting feedback when entering call notes. Contact your Coach account
            representative if you'd like to learn more.`}
          </p>
        )}
        {tooltipChoice === TooltipChoice.NO_FEEDBACK && (
          <p>
            {name} did not respond to any of the {totalRequests} feedback requests in this period.
            Feedback requests are displayed in the top left of {name}'s dashboard, and can be
            responded to from there. It's important for managers to be responsive to feedback
            requests from their direct reports.
          </p>
        )}
        {tooltipChoice === TooltipChoice.LESS_THAN_HALF && (
          <p>
            {name} responded to less than half of the {totalRequests} feedback requests during this
            period. This can be a sign of a manager having too little time to devote to coaching.
          </p>
        )}
        {tooltipChoice === TooltipChoice.MANY_RESPONDED && (
          <p>
            {name} responded to {requestsRespondedTo} out of {totalRequests} feedback requests in
            this period, i.e. listened to, highlighted, commented, and/or scored the calls that
            agents had requested be reviewed.
          </p>
        )}
        {tooltipChoice === TooltipChoice.ALL_RESPONDED && (
          <p>
            {name} responded to ALL feedback requests in this period. Responding to all feedback
            requests from agents shows a high degree of focus on coaching by this manager. Great
            work by {name}!
          </p>
        )}
      </div>
    );
  }
}
